<template>
  <div style="height: 100%;">
    <el-container style="height: 100%;">
      <el-main style="height: 100%;">
        <div class="talk_show"
             id="words"
             ref="main"
             :key="time">
          <!-- 根据vue对象中的数组，遍历出对应的标签。 -->
          <div ref="content"
               class="message-item">
            <div class="flex">
              <div class="message-avatar float">
                <figure class="avatar">
                  <img :src="getfirstimg()"
                       class="rounded-circle" />
                </figure>
              </div>
              <div style="margin-right: auto; text-align: left">
                <div style="padding-bottom:4px">
                  <h5>{{msgType==1?'沙盘精灵':'administrator'}}</h5>
                </div>
                <div class="message-content float">

                  <span>{{msgType==1?'欢迎大家积极踊跃向我提问哦':'欢迎大家积极踊跃参加策略交流聊天哦'}}</span>
                </div>
              </div>
            </div>
          </div>
          <div ref="content"
               v-for="i in msgType == 0 ? msgList : SPmsgList"
               :class="
              i.username != role
                ? 'message-item'
                : 'message-item outgoing-message'
            "
               :key="i.words">
            <div class="flex"
                 v-if="i.username == role">
              <div style="margin-left: auto; text-align: right">
                <div style="padding-bottom: 4px">
                  <h5>{{ getrole(i.username) }}</h5>
                </div>
                <div class="message-content float">
                  <button @click="location(i.msg)"
                          v-if="i.msg.indexOf('https://www.baidu.com/s?wd=') != -1">
                    点我搜索
                  </button>
                  <span v-else>{{ i.msg }}</span>
                </div>
              </div>
              <div class="message-avatar float">
                <figure class="avatar">
                  <img :src="getimg(i.username)"
                       class="rounded-circle" />
                </figure>
              </div>
            </div>
            <div class="flex"
                 v-else>
              <div class="message-avatar float">
                <figure class="avatar">
                  <img :src="getimg(i.username, i)"
                       class="rounded-circle" />
                </figure>
              </div>
              <div style="margin-right: auto; text-align: left">
                <div style="padding-bottom:4px">
                  <h5>{{ getrole(i.username) }}</h5>
                </div>
                <div class="message-content float">
                  <button @click="location(i.msg)"
                          v-if="i.msg.indexOf('https://www.baidu.com/s?wd=') != -1">
                    点我搜索
                  </button>
                  <span v-else>{{ i.msg }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="message-content" v-else>
              <el-image
                style="width: 100px; height: 100px"
                :src="i.msg"
                :preview-src-list="srcList"
              >
              </el-image>
            </div> -->
          </div>
          <!-- <div ref="content"
               v-show="ischat"
               class="message-item">
            <div class="flex">
              <div class="message-avatar float">
                <figure class="avatar">
                  <img :src="getfirstimg()"
                       class="rounded-circle" />
                </figure>
              </div>
              <div style="margin-right: auto; text-align: left">
                <div style="padding-bottom:4px">
                  <h5>{{msgType==1?'沙盘精灵':'administrator'}}</h5>
                </div>
                <div class="message-content float">

                  <span>{{this.chatContent}}</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div id="send">
          <el-input type="textarea"
                    placeholder="请输入内容,回车键发送"
                    v-model="inputStr"
                    maxlength="200"
                    @keydown="sendMsg($event)"
                    :autosize="{ minRows: 4 }"
                    show-word-limit></el-input>
          <el-button @click="sendMsgclick()"
                     type="primary"
                     size="small"
                     :loading="ischat"
                     style="position: absolute; right: 9px; bottom: 24px">发送</el-button>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import axios from "axios";
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

export default {
  data () {
    return {
      chatContent: "",
      ischat: false,
      msgType: "",
      time: new Date().getTime(),
      inputStr: "",
      zhixincount: 1,
    };
  },
  created () {
    this.role = this.$route.path;
  },

  mounted () {
    this.$nextTick(() => {
      var container = this.$el.querySelector(".talk_show");
      container.scrollTop = container.scrollHeight;
    });

  },
  watch: {
    $route (to) {
      this.time = new Date().getTime();
      this.role = to.path;
    },
    msgType: {
      handler () {
        this.scrollToBottom();

      },
      deep: true, // 深度监听
      immediate: true, //立即执行
    },
    msgList: {
      handler () {
        this.scrollToBottom();
      },
      deep: true, // 深度监听
      immediate: true, //立即执行
    },
    SPmsgList: {
      handler () {
        this.scrollToBottom();
      },
      deep: true, // 深度监听
      immediate: true, //立即执行
    },
  },
  computed: {
    ...mapState({
      msgList: (state) => state.user.msg,
      SPmsgList: (state) => state.user.SPmsg,
      Round: (state) => state.user.round,
    }),
  },
  methods: {
    getfirstimg () {

      return require(this.msgType == 1 ? '../../assets/images/RoleImg/沙盘精灵.png' : '../../assets/images/RoleImg/administrator.png');
    },
    location (href) {
      window.open(href, "_blank");
    },
    getimg (name, i) {
      console.log(i);
      if (name == null) return;
      return require("../../assets/images/RoleImg" + name + ".png");
    },
    getrole (name) {
      switch (name) {
        case "/ProjectManagement":
          return "项目管理";
        case "/MiceMarketing":
          return "会展营销";
        case "/DataAnalysis":
          return "数据分析";
        case "/ExhibitionServices":
          return "会展服务";
        case "/FinancialManagement":
          return "财务管理";
        // case "/Financial":
        //   return "财务管理部";
        case "/沙盘精灵":
          return "沙盘精灵";
        case "/administrator":
          return "administrator";
      }
    },
    scrollToBottom () {
      this.$nextTick(() => {
        var container = this.$el.querySelector(".talk_show");
        container.scrollTop = container.scrollHeight;
      });
    },
    send () {
      if (this.inputStr == "") return;
      // event.preventDefault();
      if (this.msgType == 0) {
        this.Global.sendmsgmd(this.$route.path, this.inputStr, 5);
        this.inputStr = "";
        this.scrollToBottom();
      } else {
        this.Global.sendmsgmd(this.$route.path, this.inputStr, 4);
        try {
          this.ischat = true;
          var gid = this.uuid.guid();
          this.zhixincount = 1;
          // 创建 XMLHttpRequest 对象
          const xhr = new XMLHttpRequest();
          // 设置请求的 URL
          xhr.open('GET', this.Global.chaturl + `api/Chat/ChatWPFStreamMD?massage=${this.inputStr}`);
          // 设置响应类型为 text/event-stream
          xhr.setRequestHeader('Content-Type', 'text/event-stream');
          // 监听 readyStateChange 事件
          xhr.onreadystatechange = () => {
            // 如果 readyState 是 3，表示正在接收数据
            if (xhr.readyState === 3) {
              this.chatContent = xhr.responseText;
              const index = this.SPmsgList.findIndex(item => item.guid === gid)
              if (index >= 0) {
                const dialog = this.SPmsgList[index]
                dialog.msg = xhr.responseText
              }
              else {
                this.$store.commit('chageSPmsg', {
                  username: "/沙盘精灵",
                  msg: xhr.responseText,
                  msgtype: 4,
                  time: new Date().format('yyyy-MM-dd hh:mm'),
                  msgState: 2,
                  money: this.$store.state.user.Money,
                  depcount: this.$store.state.user.depcomit,
                  group: localStorage.getItem('accessToken'),
                  guid: gid,
                })
              }
              this.scrollToBottom();
              // this.chatContent = xhr.responseText;
            }
            // 如果 readyState 是 4，表示完成请求
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                this.$http
                  .get(
                    "StudentData/GetAddStepOperationSend?round=" + this.Round
                  )
                  .then((res) => {
                    if (res.success) {
                      this.ischat = false;
                    }
                  });
                // 避免接受过程中缺少字符
                this.Global.sendmschatgmd("/沙盘精灵", xhr.responseText, 4, gid);
                //this.chatContent = xhr.responseText;
              }
            }
          }
          // 发送请求
          xhr.send();
          this.inputStr = "";
          this.scrollToBottom();

        } catch (error) {
          this.ischat = false;
          console.log(error);
          this.Global.sendmsgmd("/沙盘精灵", "网络开小差啦！", 4);
          this.inputStr = "";
        }
      }
    },
    sendMsgclick () {
      this.send();
    },
    sendMsg (event) {
      //   var route = this.$route.path.split("/");
      //   console.log(this.$route.path);
      //   route = this.getbum(route[1]);
      if (event.keyCode == 13) {
        if (!event.shiftKey) {
          if (this.ischat) {
            this.$message.warning("等待上一个执行完成");
          }
          else this.send();
        } else {
          this.inputStr = this.inputStr + "\n";
        }
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/send/scoket.css";
.message-item {
  margin-bottom: 1rem;
  max-width: 80%;
  margin-left: 10px;
  margin-top: 10px;
}
.message-item .message-avatar {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-left: 10px;
}
.message-item .message-content {
  background: #ebebeb;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
  padding: 10px 20px;
  font-size: 14px;
}
.message-item .message-avatar .avatar {
  margin-right: 1rem;
}
.message-item .message-avatar h5 {
  font-size: 15px;
  margin-bottom: 0;
}
.time {
  color: #828282;
  margin-top: 2px;
  font-style: italic;
  font-size: 12px;
}
.message-item .message-content {
  background: #ebebeb;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
  padding: 10px 20px;
  text-align: left;
}
.message-item.outgoing-message {
  margin-left: auto;
  padding-right: 10px;
}
.message-item.outgoing-message .message-avatar {
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -moz-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.message-item.outgoing-message .message-content {
  background-color: #0a80ff;
  color: #fff;
  text-align: right;
  font-size: 14px;
  margin-left: auto;
}
.message-content {
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  text-align: left;
  word-break: break-word;
}
figure.avatar > a > img,
figure.avatar > img {
  /* width: 100%;
  height: 100%; */
  -o-object-fit: cover;
  object-fit: cover;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.flex {
  display: flex;
}
.talk_show{
    height: 80%;
  }
</style>